import React from 'react';
import {useDispatch, useSelector} from "react-redux";

export const PopupWindow = () =>{
	const dispatch = useDispatch();
	const popupWindow = useSelector(store=>store.Store.PopupWindow.status)
	return popupWindow? <div id="popup-window" onClick={()=>dispatch({type: 'POPUP_WINDOW', payload:false})}/>: null
}
